import * as React from "react";
import { Box, Stack } from "@telefonica/mistica";

interface IProps {
	children: React.ReactNode;
}

export const TextList: React.FC<IProps> = (props) => {
	const { children } = props;
	return (
		<Box padding={16} className="card-background-alternative">
			<Stack space={8} >
				{children}
			</Stack>
		</Box>
	);
};
